import React from 'react';
import { subscribeGallery } from '../lib/gallery';
import { currentDevice, observeDevice } from '../lib/layout';

class Highlights extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // null heisst: noch nichts geladen, siehe landing.js.
            items: null,
            columns: null,
            // Geraeteklasse statt Breite: ein Tablet zaehlt nicht als Rechner.
            geraet: currentDevice()
        }
    }

    componentDidMount() {
        var that = this;
        this.disposeDevice = observeDevice(function (geraet) {
            that.setState({ geraet: geraet });
        });
        this.unsubscribe = subscribeGallery(function (gallery) {
            that.setState({
                items: gallery.highlights.items,
                columns: gallery.highlights.columns
            });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
        if (this.disposeDevice) {
            this.disposeDevice();
        }
    }

    render() {
        if (!this.state.items) {
            return <div class='fullwidthcontainer' />;
        }
        // Eine Spalte entspricht der frueheren vollen Breite; mehr Spalten
        // teilen die Zeile ueber dieselbe CSS-Variable wie bei den
        // Schmuckstuecken. Nur das erste Bild sofort, der Rest beim Scrollen.
        var spalten = this.state.columns[this.state.geraet];
        var list = this.state.items.map(function (item, index) {
            return <img src={item.src} alt='Highlight' class='smallimage' key={item.src}
                loading={index === 0 ? 'eager' : 'lazy'} decoding='async' />;
        });
        return (
            <div class='fullwidthcontainer' style={{ '--spalten': spalten }}>
                {list}
            </div>
        );
    }
}

export default (Highlights);
